import { render, staticRenderFns } from "./UserModulesDataTable.vue?vue&type=template&id=69e9ef96"
import script from "./UserModulesDataTable.vue?vue&type=script&lang=js"
export * from "./UserModulesDataTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports